import { Row, Col } from 'antd'
import './GradingScoreSummary.style.less'

interface Props {
  data?: {
    score?: number
    weight?: number
    percent?: number
    rating?: string
    non_compliant?: {
      status?: boolean
      reasons?: { type?: string; section?: string; min_percent?: number }[]
    }
  }
  // Company setting "fcca".non_compliant.status
  nonCompliantEnabled?: boolean
  fccaRatingSetting?: any[]
  auditRatingTitles?: {
    rating?: string
    grading_score?: string
  }
}

function GradingScoreCard(props: Props) {
  const {
    data,
    nonCompliantEnabled = false,
    fccaRatingSetting = [],
    auditRatingTitles,
  } = props

  const sortedSettings = [...fccaRatingSetting].sort(
    (a, b) => (a.score || 0) - (b.score || 0)
  )

  // A Non Compliant audit always gets the lowest grade, whatever its score
  const isNonCompliant =
    nonCompliantEnabled && data?.non_compliant?.status === true
  const grade =
    (isNonCompliant ? sortedSettings[0]?.grade : undefined) ??
    data?.rating ??
    ''

  const getGradeColor = (grade?: string): string => {
    if (!grade) return '#848484'
    const setting = fccaRatingSetting.find(
      (s) => s.grade?.toUpperCase() === grade.toUpperCase()
    )
    return setting?.color || setting?.background_color || '#848484'
  }

  const gradingScale = fccaRatingSetting.map((item) => {
    const settingIndex = sortedSettings.findIndex((s) => s.grade === item.grade)
    const startScore =
      settingIndex > 0 ? (sortedSettings[settingIndex - 1].score || 0) + 1 : 0
    const endScore = item.score || 0

    return {
      range: `${item.grade} = ${startScore}% - ${endScore}%`,
      label: item.description || '',
      color: item.color || item.background_color || '#848484',
    }
  })
  const displayScale = gradingScale.length > 0 ? gradingScale : []

  return (
    <div className="grading-score-card-container">
      <Row gutter={0} className="grading-score-content">
        <Col span={12} className="rating-section">
          <div className="rating-header">
            {auditRatingTitles?.rating ?? 'FCCA Rating'}
          </div>
          <div
            className="rating-grade"
            style={{ backgroundColor: getGradeColor(grade) }}
          >
            <span className="grade-letter">{grade}</span>
          </div>
        </Col>

        <Col span={12} className="grading-score-section">
          <div className="grading-score-header">
            {auditRatingTitles?.grading_score ?? 'Grading Score'}
          </div>
          <div className="grading-scale-list">
            {displayScale.map((item, index) => (
              <Row key={index} className="grading-scale-item">
                <Col span={8}>
                  <span className="grade-range" style={{ color: item.color }}>
                    {item.range}
                  </span>
                </Col>
                <Col span={16}>
                  <span className="grade-label" style={{ color: item.color }}>
                    {item.label}
                  </span>
                </Col>
              </Row>
            ))}
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default GradingScoreCard
